import BaseCollection from "nexia_mobile/models/base_collection";
import Automation from "nexia_mobile/models/automation";
import { ResourceMap } from "nexia_mobile/framework/resource";

export default class AutomationCollection extends BaseCollection {
  model = Automation;

  parse(attrs, ...args) {
    let automations = super.parse(attrs, ...args);
    return this._recycleAutomations(attrs, automations);
  }

  async _parseModelsAsync(attrs, ...args) {
    let automations = await super._parseModelsAsync(attrs, ...args);
    return this._recycleAutomations(attrs, automations);
  }

  _recycleAutomations(attrs, automations) {
    let items = attrs.items || attrs.result;
    if (!items) {
      return automations;
    }
    if (!_.isArray(items) && items.items) {
      ({ items } = items);
    }

    // Jump through hoops to try to find an existing Automation
    // model and just set attributes on it, if one is available.
    return automations.map((automation, index) => {
      let automationData = items[index];
      let existingAutomation = ResourceMap.findByHref(automation.id);
      if (existingAutomation) {
        delete automationData.id;
        return existingAutomation.set(automationData, { parse: true });
      } else {
        return automation;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/automation_collection.js